// extracted by mini-css-extract-plugin
export default {"number":"Ix8uX","number--selected":"lqxVa","circle":"vpk3H","loadingOff":"iXvZY","loadingOn":"kRVGx","active":"fG72y","inactive":"AF7zp","rotate":"LyLic","dissolve":"ihfpa"};